<template>
    <div class="about">
        <BasicNavigation header-image="header_tiketing.png"></BasicNavigation>
        <v-flex text-xs-center pt-3>
            <h1>Pembelian Tiket untuk Group (Sekolah)</h1>
        </v-flex>
        <KelompokList></KelompokList>
    </div>
</template>

<script>
    import BasicNavigation from "@/components/BasicNavigation";
    import KelompokList from "@/components/kelompok/List";

    export default {
        components: {
            BasicNavigation,
            KelompokList,
        }
    }
</script>